import e from "./generateUtilityClasses.mjs";
import t from "./generateUtilityClass.mjs";
const l = (i) => t("MuiPickersSlideTransition", i), n = e("MuiPickersSlideTransition", ["root", "slideEnter-left", "slideEnter-right", "slideEnterActive", "slideExit", "slideExitActiveLeft-left", "slideExitActiveLeft-right"]);
export {
  l as getPickersSlideTransitionUtilityClass,
  n as pickersSlideTransitionClasses
};
//# sourceMappingURL=pickersSlideTransitionClasses.mjs.map
